<template>
  <section class="container mx-auto py-14">
    <UtilsSkeletonLoading
      v-if="isLoading"
      class="mx-auto w-4/5 h-28 sm:h-[315px] md:h-[495px] mt-3"
    />
    <iframe
      v-else
      :src="companyVideo.attributes?.video_url"
      class="mx-auto w-full h-[315px] md:h-[495px] lg:h-[670px] mt-3"
    ></iframe>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const companyVideo = ref([])

const getCompanyVideo = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/life-at-suitmedia-career`,
    {
      query: {
        'fields[0]': 'id',
        'fields[1]': 'video_url'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Company Video does not exist`
    })
  }

  return data.value
}

const video = await getCompanyVideo()
companyVideo.value = video.data
</script>

<style lang="scss" scoped></style>
